const Local = () => {
  return (
    <section id="local">
      <div className="container">
        <div className="mapa">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3752.7019854153364!2d-43.987426089462076!3d-19.852558735824143!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa691ac435e0447%3A0x8d81da3399bebdc1!2sAv.%20Otac%C3%ADlio%20Negr%C3%A3o%20de%20Lima%2C%204928%20-%20Pampulha%2C%20Belo%20Horizonte%20-%20MG%2C%2031340-565!5e0!3m2!1spt-BR!2sbr!4v1697832406719!5m2!1spt-BR!2sbr"
            width="100%"
            allowfullscreen=""
            loading="lazy"
            title="Local"
          ></iframe>

          <div className="row justify-content-center" style={{marginTop: '20px'}}>
            <div className="col-10 col-md-5 px-0 nome">
                CASA PAMPULHA
            </div>
            <div className="col-10 col-md-5 px-0 endereco">
                Av. Otacílio Negrão de Lima, 4928 - Pampulha, Belo Horizonte - MG, 32310-210
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Local;
